import {
  CLIENT_REQUEST_FAILURE,
  CLIENT_REQUEST_SUCCESS,
  CLIENT_FETCH,
} from './actionTypes';

export default function reducer(state = {}, action) {
  switch (action.type) {
    case CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        clientName: action.clientName,
      };
    default:
      return state;
  }
}

// actions
export function updateClient(clientName) {
  return {
    type: CLIENT_REQUEST_SUCCESS,
    clientName,
  };
}

export function clientRequestFailure(error) {
  return {
    type: CLIENT_REQUEST_FAILURE,
    error,
  };
}

export function getClient() {
  return {
    type: CLIENT_FETCH,
  };
}
